import { CommonModule } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { LeadService } from '../../../service/lead.service';

@Component({
  selector: 'app-mobile-premium-form',
   imports: [TranslatePipe,CommonModule,ReactiveFormsModule],
  templateUrl: './mobile-premium-form.component.html',
  styleUrl: './mobile-premium-form.component.scss'
})
export class MobilePremiumFormComponent {
/** Selected insurance */
selectedInsurance: string | null = null;
  isLoading: boolean=false;

  /** List of gender */
  gender = ['MALE','FEMALE'];

  /** dropdown value */
  activeDropdown: string | null = null;

  /** List of age */
  // age=['16-19', '20-24', '25-29', '30-34', '35-39', '40-44', '45-49', '50-54','55-59', '60-64', '65'];

  age = Array.from({ length: 65 - 16 + 1 }, (_, i) => i + 16);


  /** List of contract */
  contract=['With labor contract','Without labor contract'];

  /** List of insurance */
  insurance=['GOLD','SILVER','BRONZE'];

  /** Selected gender */
  selectedGender: string | null = null;

  /** Selected contract */
  selectedContract: string | null = null;

  /** Service to handle lead API calls */
  leadService = inject(LeadService);

  /** Angular FormGroup for lead submission */
  form!: FormGroup;

  /** Selected age */
  selectedAge:number |null =null;

  /** FormBuilder service for reactive forms */
  fb = inject(FormBuilder);

  /** Current language */
  private currentLang!: string ;

  /** Current query */
  private currentQueryParams: any = {};  

  // ---------- Constructor & Form Setup ----------
  constructor( private router: Router,
      private _actRoute: ActivatedRoute
  ) {
    // Initialize reactive form with validators
    this.form = this.fb.group({
       insuranceType: ['', Validators.required],
       // MoEngage tracking removed, use CleverTap for event tracking
      contractType: ['', Validators.required],
      gender: ['', Validators.required],
      age: ['', Validators.required]
    });
  }
    
  /** Angular hooks */
  ngOnInit() {
    // Track page visit with traffic source
    // const trafficSource = this.getTrafficSource();
    // Removed MoEngage tracking, use CleverTap instead
    //   product: 'income_protection',
    //   traffic_source: trafficSource
    // });
    this.currentLang = this.router.url.split('/')[1]; // 0: "income-protection-insurance", 1: "vi"
    console.log('Lang from ActivatedRoute:', this.currentLang);
    this._actRoute.queryParams.subscribe((queryParams) => {
      this.currentQueryParams = { ...queryParams };
    });
  }
  /** Selects a contact type and updates the form */
  selectInsurance(insurance:string){
    this.selectedInsurance = insurance;
    this.form.get('insuranceType')?.setValue(insurance);
  }
    /** close dropdown*/
  closeDropdown() {
    this.activeDropdown = null;
  }
    /** toggle dropdown*/
  toggleDropdown(name: string,event:any) {
    event?.stopPropagation();
    this.activeDropdown = this.activeDropdown === name ? null : name;
  }

  // Listen for clicks on the document to close dropdowns if click is outside
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    // ✅ allow clicks inside dropdown-container OR inside calendar component
    if (target.closest('.dropdown-container')) {
      return;
    }
    this.closeDropdown();
  }

  /** Selects a gender and updates the form */
  selectGender(gen: string) {
    this.selectedGender = gen;
    this.form.get('gender')?.setValue(gen);
  }

  /** Selects a age and updates the form */
  selectAge(age:number){
    this.selectedAge = age;
    this.form.get('age')?.setValue(age);
  }

  /** Selects a contact type and updates the form */
selectContract(con: string) {
  this.selectedContract = con;
    this.form.get('contractType')?.setValue(con);
}

    // ---------- Form Submission ----------
  /** Submits the lead form after validation and triggers phone verification */
onSubmit() {
  if (this.form.invalid) {
    console.log('Form is invalid');
    this.form.markAllAsTouched();
    return;
  }
 const payload={
      age: this.form.get('age')?.value,
      gender: this.form.get('gender')?.value,
      interestPlan: this.form.get('insuranceType')?.value,
      contractType: this.form.get('contractType')?.value === 'With labor contract' ? 'WITH_LABOR_CONTRACT': 'WITHOUT_LABOR_CONTRACT'
      }
  this.isLoading = true; // ✅ start loader

      console.log("payload:",payload);
      this.leadService.premiumCalculation(payload).subscribe({      
      next: (response) => {
      this.form.reset();
      this.isLoading = false; // ✅ stop loader
      this.leadService.setResponseData(response.data.premium);
      const basePath = [this.router.url.split('/')[2]];  
      this.router.navigate([this.currentLang,...basePath, 'mobile-premium-details'], {
          queryParams: this.currentQueryParams
                }).then(() => {
        window.scrollTo(0, 0);
        });
      },
      error: (err) => {
      console.error('Error submitting lead:', err);
      this.isLoading = false; // ✅ stop loader
      }
      });
    }

onBack(){
    const basePath = [this.router.url.split('/')[2]];
    this.router.navigate([this.currentLang, ...basePath,'mobile-premium'], {
      queryParams: {
         ...this.currentQueryParams
      }
    });
}

}


